import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../../components/Modal";
import { EDIT_FAVOURITES_VIEW } from "../../../../constants";
import styles from "./EditFavourites.module.scss";
import { FavView } from "../../components/FavView";
import { EditFavouritesHeader } from "../../components/EditFavouritesHeader";
import DeleteIcon from "../../../../assets/icons/delete_icon.svg";
import { sendMessage, sendAnalyticsEvent } from "../../../../lib/postMessage";
import { ALL, DELETE, FAVOURITES } from "../../../../constants/analytics";
import { SET_ACTIVE_VIEW } from "../../../../constants/actions";

export const EditFavourites = () => {
  const dispatch = useDispatch();
  const { storedFavourites } = useSelector((state) => state.filter);
  const { id } = useSelector((state) => state.favourites);
  const { activeView, previousView } = useSelector((state) => state.view);
  if (activeView !== EDIT_FAVOURITES_VIEW) return null;

  function deleteFavourite() {
    const newFavourites = storedFavourites.filter(
      (favourite) => favourite.id !== id
    );
    sendMessage({
      type: "UpdateFavourites",
      payload: newFavourites,
    });

    sendAnalyticsEvent({
      event: FAVOURITES,
      type: ALL,
      action: DELETE,
    });

    dispatch({
      type: "CLEAR_ALL_FAVOURITES_SELECTIONS",
    });

    dispatch({
      type: SET_ACTIVE_VIEW,
      payload: previousView ?? "",
    });
  }

  return (
    <Modal variant={EDIT_FAVOURITES_VIEW}>
      <div className={styles.editFavouritesView}>
        <EditFavouritesHeader />
        <FavView />
      </div>
      <button
        type="button"
        className={styles.deleteFavourite}
        onClick={deleteFavourite}
      >
        <img
          src={DeleteIcon}
          alt="Delete Favourite"
          className={styles.deleteFavouriteIcon}
        />
        <span className={styles.deleteFavouriteText}>Delete Favourite</span>
      </button>
    </Modal>
  );
};
